import { useMemo, useState } from 'react'
import { errorHandler } from '../../../../services/util/error.service'
import * as AjudanteHttp from '../../../../services/api/https/registration/ajudante.http'
import { gerarArquivoExcel } from '../../../../services/util/excel.service'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  INITIAL_GET: 'Adquirindo informações dos ajudantes',
}

const INITIAL_STATE = {
  ajudantes: [],
  modal: {
    show: false,
    data: null,
  },
  ajudante: {},
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
  selectedTp: 0,
  globalFilter: '',
}

export default function useAjudante() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    return {
      // Actions
      getAjudantes(selectedTp) {
        if (selectedTp === 0)
          setState(prevState => ({ ...prevState, errorMessage: 'Selecione um TP' }))
        else
          AjudanteHttp.getAjudantes(selectedTp)
            .then(ajudantes => {
              setState(prevState => ({
                ...prevState,
                ajudantes: ajudantes,
                loadingMessage: LOAD_MESSAGE.NONE,
              }))
            })
            .catch(err =>
              setState(prevState => ({
                ...prevState,
                errorMessage: errorHandler(err),
                loadingMessage: LOAD_MESSAGE.NONE,
              })),
            )
      },

      resetState() {
        setState({ ...INITIAL_STATE })
      },

      // Events
      onInit(selectedTp) {
        setState(prevState => ({
          ...prevState,
          selectedTp: selectedTp,
          loadingMessage: LOAD_MESSAGE.INITIAL_GET,
        }))
      },
      onBtnNovo() {
        setState(prevState => ({ ...prevState, modal: { show: true, data: null } }))
      },
      onModalClose() {
        setState(prevState => ({ ...prevState, modal: { show: false, data: null } }))
      },
      onModalSave(ajudante) {
        setState(prevState => {
          prevState.modal = { show: false, data: null }
          const index = prevState.ajudantes.findIndex(
            ajudanteAux => ajudanteAux.id === ajudante.id,
          )
          if (index !== -1) prevState.ajudantes[index] = ajudante
          else prevState.ajudantes.unshift(ajudante)
          prevState.loadingMessage = LOAD_MESSAGE.NONE
          return { ...prevState }
        })
      },
      onDataTableItemClicked(ajudante) {
        setState(prevState => ({
          ...prevState,
          modal: {
            show: true,
            data: {
              ...ajudante,
            },
          },
        }))
      },
      onGlobalFilterChange(value) {
        setState(prevState => ({ ...prevState, globalFilter: value }))
      },
      onBtnExportarExcelClick(ajudantes) {
        const colunas = [
          ['nome (string)*', 'cpf (int)', 'telefone_contato (int)', 'endereco (string)', 'ativo (0,1)*'],
        ]

        ajudantes.forEach(e => {
          colunas.push([e.name, e.cpf, e.phone, e.address, e.actived ? 1 : 0])
        })

        gerarArquivoExcel('Ajudantes', colunas, 'ajudantes.xlsx')
      },
    }
  }, [])

  return { state, localDispatch }
}

